import { render, staticRenderFns } from "./MathLiveEditor.vue?vue&type=template&id=18059bcd"
import script from "./MathLiveEditor.vue?vue&type=script&lang=js"
export * from "./MathLiveEditor.vue?vue&type=script&lang=js"
import style0 from "./MathLiveEditor.vue?vue&type=style&index=0&id=18059bcd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports